import React, { useEffect, useState } from 'react';
import Moment from "moment";
import 'chartjs-plugin-datalabels';
import { Card, CardBody, CardTitle, Col,  Row } from "reactstrap";

import { showLoader } from "../../../components/loader/loader";
import { showToastCustom } from "../../../components/toast/customToast";
import { error } from "../../../components/i18n/i18n";
import { CardChartBar } from "../../../components/charts/ChartBar";
import { getFirstDayOfMonth, getLastDayOfMonth} from "../../../util/DateTools";
import {photoDashboardService} from "../../../jwt/_services/bi/photoDashboardService";
import PhotoDashboardFilters from "./_filters";
import CardChartHeat from "../../../components/charts/ChartHeat";

export default function PhotoDashboard() {
    const [loading, setLoading] = useState(false);
    const today = new Date()

    const [dataFilter, setDataFilter] = useState({
        type : 'redeemed',
        to : Moment( getLastDayOfMonth(today.getFullYear(), today.getMonth()) ).format('YYYY-MM-DD'),
        from : Moment( getFirstDayOfMonth(today.getFullYear(), today.getMonth()) ).format('YYYY-MM-DD')
    });

    // RedeemedTotal
    const [redeemedTotal, setRedeemedTotal] = useState(null);
    const [redeemedTotalRaw, setRedeemedTotalRaw] = useState(null);
    const [redeemedTotalHeaders, setRedeemedTotalHeaders] = useState(null);

    // RedeemedByUdn
    const [redeemedByUdn, setRedeemedByUdn] = useState(null);
    const [redeemedByUdnRaw, setRedeemedByUdnRaw] = useState(null);
    const [redeemedByUdnHeaders, setRedeemedByUdnHeaders] = useState(null);

    // SharesTotal
    const [sharesTotal, setSharesTotal] = useState(null);
    const [sharesTotalRaw, setSharesTotalRaw] = useState(null);
    const [sharesTotalHeaders, setSharesTotalHeaders] = useState(null);

    // SharesByUdn
    const [sharesByUdn, setSharesByUdn] = useState([]);

    // Delta Photo Code Redeem
    const [photoCodeDeltaRedeem, setPhotoCodeDeltaRedeem] = useState(null);
    const [photoCodeDeltaRedeemRaw, setPhotoCodeDeltaRedeemlRaw] = useState(null);
    const [photoCodeDeltaRedeemHeaders, setPhotoCodeDeltaRedeemHeaders] = useState(null);

    // Delta Photo Share Visit
    const [photoShareDeltaVisit, setPhotoShareDeltaVisit] = useState(null);
    const [photoShareDeltaVisitRaw, setPhotoShareDeltaVisitRaw] = useState(null);
    const [photoShareDeltaVisitHeaders, setPhotoShareDeltaVisitHeaders] = useState(null);

    // Delta Photo Share Redeem
    const [photoShareDeltaRedeem, setPhotoShareDeltaRedeem] = useState(null);
    const [photoShareDeltaRedeemRaw, setPhotoShareDeltaRedeemlRaw] = useState(null);
    const [photoShareDeltaRedeemHeaders, setPhotoShareDeltaRedeemHeaders] = useState(null);

    useEffect(() => {
        refreshDashboard(dataFilter);
    }, []);

    const refreshFiltered = (_dataFilter) => {
        setDataFilter(_dataFilter);
        refreshDashboard(_dataFilter);
    }

    const refreshDashboard = ( _dataFilter ) => {
        setLoading(true);
        _dataFilter.type = 'redeemed';
        photoDashboardService.searchDashboard( _dataFilter)
            .then(result => {
                if (result){
                    setRedeemedTotal(mapTotals(result?.redeemedCodes?.byDate, setRedeemedTotalRaw, setRedeemedTotalHeaders));
                    setRedeemedByUdn(mapRedeemedByUdn(result?.redeemedCodes?.byUdn));
                } else {
                    //setRedeemedTotal(null);
                    setRedeemedByUdn(null);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setRedeemedTotal(null);
                setRedeemedByUdn(null);
                setLoading(false);
                showToastCustom(error, errorMessage);
            });

        _dataFilter.type = 'shares';
        photoDashboardService.searchDashboard( _dataFilter)
            .then(result => {
                if (result){
                    setSharesTotal(mapTotals(result?.shares?.byDate, setSharesTotalRaw, setSharesTotalHeaders));
                    setSharesByUdn(result?.shares?.byXelfieCode);
                } else {
                    setSharesTotal(null);
                    setSharesByUdn(null);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setSharesTotal(null);
                setSharesByUdn(null);
                setLoading(false);
                showToastCustom(error, errorMessage);
            });

        _dataFilter.type = 'deltas';
        photoDashboardService.searchDashboard( _dataFilter)
            .then(result => {
                if (result){
                    setPhotoCodeDeltaRedeem(mapTotals(result?.deltas?.photoCodeDeltaRedeem, setPhotoCodeDeltaRedeemlRaw, setPhotoCodeDeltaRedeemHeaders));
                    setPhotoShareDeltaVisit(mapTotals(result?.deltas?.photoShareDeltaVisit, setPhotoShareDeltaVisitRaw, setPhotoShareDeltaVisitHeaders));
                    setPhotoShareDeltaRedeem(mapTotals(result?.deltas?.photoShareDeltaRedeem, setPhotoShareDeltaRedeemlRaw, setPhotoShareDeltaRedeemHeaders));
                } else {
                    setPhotoCodeDeltaRedeem(null);
                    setPhotoShareDeltaVisit(null);
                    setPhotoShareDeltaRedeem(null);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setPhotoCodeDeltaRedeem(null);
                setPhotoShareDeltaVisit(null);
                setPhotoShareDeltaRedeem(null);
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    const mapRedeemedTotals = (_redeemedTotal) => {
        setRedeemedTotalRaw([ _redeemedTotal ])
        const _labels = Object.keys(_redeemedTotal)

        setRedeemedTotalHeaders(_labels)

        const _values = []

        _labels.forEach( (serv) => {
            _values.push( _redeemedTotal[serv] );
        });

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: [
                        'rgba(96,140,48, 1)',
                    ],
                    backgroundColor: [
                        'rgba(96,140,48, 0.60)',
                    ],
                    borderWidth: 1,
                }
            ],
        };
    }

    const mapRedeemedByUdn = (_redeemedByUdn) => {
        setRedeemedByUdnRaw(_redeemedByUdn)

        const _dates = _redeemedByUdn.map((item) => {
            return item.date;
        });

        setRedeemedByUdnHeaders(_dates)

        const _XC = _redeemedByUdn.map((item) => item.XC > 0 ? item.XC : 0);
        const _XH = _redeemedByUdn.map((item) => item.XH > 0 ? item.XH : 0);
        const _XP = _redeemedByUdn.map((item) => item.XP > 0 ? item.XP : 0);
        const _XF = _redeemedByUdn.map((item) => item.XF > 0 ? item.XF : 0);
        const _XS = _redeemedByUdn.map((item) => item.XS > 0 ? item.XS : 0);
        const _XV = _redeemedByUdn.map((item) => item.XV > 0 ? item.XV : 0);
        const _XN = _redeemedByUdn.map((item) => item.XN > 0 ? item.XN : 0);
        const _XO = _redeemedByUdn.map((item) => item.XO > 0 ? item.XO : 0);
        const _HX = _redeemedByUdn.map((item) => item.HX > 0 ? item.HX : 0);
        const _HXA = _redeemedByUdn.map((item) => item.HXA > 0 ? item.HXA : 0);
        const _LCP = _redeemedByUdn.map((item) => item.LCP > 0 ? item.LCP : 0);

        return {
            labels: _dates,
            datasets: [
                {
                    label: 'Xcaret',
                    data: _XC,
                    borderColor: 'rgb(51,153,0)',
                    backgroundColor: 'rgba(51,153,0, .60)',
                    borderWidth: 1,
                },
                {
                    label: 'Xel-Ha',
                    data: _XH,
                    borderColor: 'rgb(0,165,234)',
                    backgroundColor: 'rgba(0,165,234, .60)',
                    borderWidth: 1,
                },
                {
                    label: 'Xplor',
                    data: _XP,
                    borderColor: 'rgb(255, 102, 0)',
                    backgroundColor: 'rgba(255, 102, 0, .60)',
                    borderWidth: 1,
                },
                {
                    label: 'Xplor Fuego',
                    data: _XF,
                    borderColor: 'rgb(255, 71 , 20)',
                    backgroundColor: 'rgba(255, 71 , 20, .60)',
                    borderWidth: 1,
                },
                {
                    label: 'Xenses',
                    data: _XS,
                    borderColor: 'rgb(255, 215, 0)',
                    backgroundColor: 'rgba(255, 215, 0, .60)',
                    borderWidth: 1,
                },
                {
                    label: 'Xavage',
                    data: _XV,
                    borderColor: 'rgb(255, 4, 0)',
                    backgroundColor: 'rgba(255, 4, 0, .60)',
                    borderWidth: 1,
                },
                {
                    label: 'Xenotes',
                    data: _XN,
                    borderColor: 'rgb(1, 41, 108)',
                    backgroundColor: 'rgba(1, 41, 108, .60)',
                    borderWidth: 1,
                },
                {
                    label: 'Xoximilco',
                    data: _XO,
                    borderColor: 'rgb(255, 0, 153)',
                    backgroundColor: 'rgba(255, 0, 153, .60)',
                    borderWidth: 1,
                },
                {
                    label: 'Hotel Xcaret México',
                    data: _HX,
                    borderColor: 'rgb(165, 140, 128)',
                    backgroundColor: 'rgba(165, 140, 128, .60)',
                    borderWidth: 1,
                },
                {
                    label: 'Hotel Xcaret Arte',
                    data: _HXA,
                    borderColor: 'rgb(117, 39, 162)',
                    backgroundColor: 'rgba(117, 39, 162, .60)',
                    borderWidth: 1,
                },
                {
                    label: 'La Casa de la Playa',
                    data: _LCP,
                    borderColor: 'rgb(212, 140, 121)',
                    backgroundColor: 'rgba(212, 140, 121, .60)',
                    borderWidth: 1,
                },
            ],

        };
    }

    const mapSharedTotals = (_sharedTotals) => {
        setSharesTotalRaw([ _sharedTotals ])
        const _labels = Object.keys(_sharedTotals)

        setSharesTotalHeaders(_labels)

        const _values = []

        _labels.forEach( (serv) => {
            _values.push( _sharedTotals[serv] );
        });

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: [
                        'rgba(96,140,48, 1)',
                    ],
                    backgroundColor: [
                        'rgba(96,140,48, 0.60)',
                    ],
                    borderWidth: 1,
                }
            ],
        };
    }

    const mapTotals = (_sharedTotals, _setRaw, _setHeaders) => {
        _setRaw([ _sharedTotals ])
        const _labels = Object.keys(_sharedTotals)

        _setHeaders(_labels)

        const _values = []

        _labels.forEach( (serv) => {
            _values.push( _sharedTotals[serv] );
        });

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: [
                        'rgba(96,140,48, 1)',
                    ],
                    backgroundColor: [
                        'rgba(96,140,48, 0.60)',
                    ],
                    borderWidth: 1,
                }
            ],
        };
    }


    return (
        <div>
            {loading && showLoader()}
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>
                </CardTitle>
                <PhotoDashboardFilters refreshFiltered={refreshFiltered} />
                <CardBody>
                    <Row>
                        <Col className='col-md-12'>
                            {
                                redeemedTotal != null && <CardChartBar
                                    title = 'Redenciones por dia'
                                    rawData = { redeemedTotalRaw }
                                    headers = { redeemedTotalHeaders }
                                    graphicData = { redeemedTotal }
                                />
                            }
                        </Col>
                        <Col className='col-md-12'>
                            {
                                redeemedByUdn != null && <CardChartBar
                                    title = 'Redenciones por dia y Udn'
                                    rawData = { redeemedByUdnRaw }
                                    headers = { redeemedByUdnHeaders }
                                    graphicData = { redeemedByUdn }
                                />
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col className='col-md-12'>
                            {
                                sharesTotal != null && <CardChartBar
                                    title = 'Compartidas por dia'
                                    rawData = { sharesTotalRaw }
                                    headers = { sharesTotalHeaders }
                                    graphicData = { sharesTotal }
                                />
                            }
                        </Col>
                        {
                            sharesByUdn.map((udnShare) => {
                                if (udnShare.shares == null || udnShare.shares.length === 0 )
                                    return null

                                return(
                                    <Col className='col-md-6'>
                                        <CardChartHeat cardTitle={'Xelfies mas compartidas'} chartTitle={udnShare.udn} chartColor={udnShare.udnColor} graphicData={udnShare.shares} />
                                    </Col>
                                )
                            })
                        }
                    </Row>
                    <Row>
                        <Col className='col-md-12'>
                            {
                                photoCodeDeltaRedeem != null && <CardChartBar
                                    title = 'Diferencia entre el dia de visita vs. el dia de redención'
                                    rawData = { photoCodeDeltaRedeemRaw }
                                    headers = { photoCodeDeltaRedeemHeaders }
                                    graphicData = { photoCodeDeltaRedeem }
                                />
                            }
                        </Col>
                        <Col className='col-md-12'>
                            {
                                photoShareDeltaVisit != null && <CardChartBar
                                    title = 'Diferencia entre el dia de visita vs. el dia que se comparte'
                                    rawData = { photoShareDeltaVisitRaw }
                                    headers = { photoShareDeltaVisitHeaders }
                                    graphicData = { photoShareDeltaVisit }
                                />
                            }
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
}